import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGithub } from '@fortawesome/free-brands-svg-icons'

interface IProject {
    title: string;
    description: string;
    technologies: string[];
    link?: string;
}

function Project(props: IProject) {
    const techs = props.technologies.map(tech => <small><code>{tech}</code></small>)

    return <a href={props.link} >
        <div className="relative h-full w-full bg-five/75 justify-center items-center text-two p-5 rounded-sm shadow-lg hover:-translate-y-1 transition hover:cursor-pointer hover:text-three ">
            <h1 className="text-xl font-bold text-left">{props.title}</h1>
            <div className="text-left text-base text-two">
                <p>{props.description}</p>
            </div>
            <div className="flex flex-wrap underline gap-x-2 text-two">
                {techs}
            </div>
            <a href={props.link} className="absolute bottom-0 right-0 text-one py-3 px-3">
                <FontAwesomeIcon icon={faGithub} size="lg" />
            </a>
        </div>
    </a>
}

export default Project;